import { render, staticRenderFns } from "./cardlist.vue?vue&type=template&id=3447886a&scoped=true&"
import script from "./cardlist.vue?vue&type=script&lang=js&"
export * from "./cardlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3447886a",
  null
  
)

export default component.exports